<template>
    <div id="preloader" v-show="coreGetPreloaderStatus">
        <div class="sk-three-bounce">
            <div class="sk-child sk-bounce1"></div>
            <div class="sk-child sk-bounce2"></div>
            <div class="sk-child sk-bounce3"></div>
        </div>
    </div>
    <!-- <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> -->

    <router-view/>
</template>

<script>

import {mapGetters, mapMutations} from "vuex";
import Numbro from 'numbro';
import CurrencyLanguajes from 'src/core/CurrencyLanguajes';
import {store} from "src/store";
import {CONFIG} from "src/config";

export default {
    name: "App",
    data() {
        return {
            time: 100,
            show: 1,
        };
    },
    watch: {
    },
    mounted() {
        /*this.loading(true);
        setTimeout(() => {
            this.loading(false);
        }, 500);*/
        // Number config
        Numbro.registerLanguage(CurrencyLanguajes.getDefaultLang());
        Numbro.setLanguage('es-GT');
    },
    computed: {
        ...mapGetters({
            coreGetPreloaderStatus: 'coreGetPreloaderStatus',
            //whiteLabelInfo: 'whiteLabelInfo'
        })
    },
    methods: {
        ...mapMutations(["loading"]),
    }
};
</script>
